import { memo } from 'react';
import { Box } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';
import { ClassListItemActions } from './ClassListItemActions';
import type { CommonProps } from '../../types/props';

interface Props extends Pick<CommonProps, 'onBook' | 'onDetails' | 'isEmbedded'> {
    isLessonAttended: boolean | undefined;
    isLessonLocked: boolean;
    disableActions?: boolean;
    showActions: boolean;
}

const StyledBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isEmbedded',
})<{ isEmbedded?: boolean }>(({ theme, isEmbedded }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.up(isEmbedded ? 'md' : 'lg')]: {
        width: 180,
    },
}));

const ClassListItemFooterComponent = ({
    onBook,
    onDetails,
    isLessonAttended = false,
    isLessonLocked,
    disableActions,
    showActions,
    isEmbedded,
}: Props) => (
    <StyledBox isEmbedded={isEmbedded}>
        {showActions && (
            <Box>
                <ClassListItemActions
                    isLessonAttended={isLessonAttended}
                    isLessonLocked={isLessonLocked}
                    onBook={onBook}
                    onDetails={onDetails}
                    disabled={disableActions}
                    isEmbedded={isEmbedded}
                />
            </Box>
        )}
    </StyledBox>
);

export const ClassListItemFooter = memo(ClassListItemFooterComponent);
